module.exports = __webpack_public_path__ + "static/media/21.8b1278cb.wav";